module.exports = __webpack_public_path__ + "media/process/Process-Badges-Updates-21a25fd3.svg";